export default "__VITE_ASSET__B0TS9eZi__"